import { fetchAll, createDocWithId, deleteDocById } from "./firestoreHelpers";

// Registro de cada aumento aplicado, para poder volver a ver/compartir el
// comprobante después (el modal de aumentos no lo guardaba y se perdía).
// Cada doc tiene el snapshot que necesita la tarjeta AjusteCard.
const COLL = "alquileres_aumentos_aplicados";

export const getAumentosAplicados = async () => fetchAll(COLL);

export const saveAumentoAplicado = async (data) => createDocWithId(COLL, data);

export const deleteAumentoAplicado = async (id) => deleteDocById(COLL, id);
